export function PendingAssignSvgIcon({ gender, size = '1.571rem' }) {
  const bgColor = gender === 'F' ? '#F54C9D' : '#6385C0';

  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.2694 15.7139C22.6035 15.7139 26.117 12.1962 26.117 7.85695C26.117 3.51768 22.6035 0 18.2694 0C13.9354 0 10.4219 3.51768 10.4219 7.85695C10.4219 12.1962 13.9354 15.7139 18.2694 15.7139Z"
        fill={bgColor}
      />
      <path
        d="M18.272 30.0502C18.272 24.8318 21.5808 20.4343 26.2074 18.7339C23.8355 17.356 21.1709 16.5938 18.3891 16.5938C9.31168 16.5938 0 24.4214 0 35.1807C0 41.22 23.367 39.8714 23.367 39.8714C20.2924 37.6726 18.272 34.096 18.272 30.0502Z"
        fill={bgColor}
      />
      <path
        d="M30.3682 39.6949C35.6887 39.6949 40.0019 35.3765 40.0019 30.0496C40.0019 24.7226 35.6887 20.4043 30.3682 20.4043C25.0476 20.4043 20.7344 24.7226 20.7344 30.0496C20.7344 35.3765 25.0476 39.6949 30.3682 39.6949Z"
        fill={bgColor}
      />
      <path
        d="M32.2975 32.6009C32.1218 32.6009 31.9461 32.5423 31.7997 32.3957L29.6328 30.3435V25.7114C29.6328 25.301 29.9549 24.9785 30.3649 24.9785C30.7748 24.9785 31.0969 25.301 31.0969 25.7114V29.7279L32.7953 31.3403C33.0881 31.6041 33.1174 32.0732 32.8246 32.3664C32.6781 32.513 32.4732 32.6009 32.2975 32.6009Z"
        fill="white"
      />
    </svg>
  );
}
export function WarningIcon({ warningColor, width, height }) {
  return (
    <svg width={width} height={height} viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.66303 1.28007C8.05774 0.676403 8.94226 0.676404 9.33697 1.28007L15.9883 11.4528C16.4232 12.1179 15.946 13 15.1514 13H1.84863C1.05398 13 0.576788 12.1179 1.01166 11.4528L7.66303 1.28007Z"
        fill={warningColor}
      />
      <path
        d="M8.041 8.687L7.798 5.609L7.753 4.268H9.247L9.202 5.609L8.959 8.687H8.041ZM8.5 11.081C8.272 11.081 8.083 11.006 7.933 10.856C7.783 10.706 7.708 10.517 7.708 10.289C7.708 10.055 7.783 9.863 7.933 9.713C8.083 9.563 8.272 9.488 8.5 9.488C8.728 9.488 8.917 9.563 9.067 9.713C9.217 9.863 9.292 10.055 9.292 10.289C9.292 10.517 9.217 10.706 9.067 10.856C8.917 11.006 8.728 11.081 8.5 11.081Z"
        fill="white"
      />
    </svg>
  );
}
export function TransferInOutIcon({ gender }) {
  const bgColor = gender === 'F' ? '#F54C9D' : '#6385C0';

  return (
    <svg width="1.571rem" height="1.785rem" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8051_225912)">
        <path
          d="M2.74105 5.4317C4.25489 5.4317 5.4821 4.21577 5.4821 2.71585C5.4821 1.21593 4.25489 0 2.74105 0C1.22721 0 0 1.21593 0 2.71585C0 4.21577 1.22721 5.4317 2.74105 5.4317Z"
          fill={bgColor}
        />
        <path
          d="M18.5355 16.9534L14.4137 16.923L12.3273 13.7005L10.9158 11.4609L10.6499 11.0353L10.476 10.7516L8.03158 6.8906L10.9056 6.80953L11.3454 9.71792C11.4374 10.3563 12.0409 10.7921 12.6852 10.7009C13.3296 10.6097 13.7694 10.0118 13.6773 9.37337L13.2784 6.74872L13.1557 5.90762C13.033 5.05638 12.2761 4.43822 11.417 4.45849L10.5681 4.47876L6.99857 4.56996C6.86561 4.56996 6.7531 4.6105 6.63037 4.65103L6.60991 4.62063L3.90977 6.30284C3.23474 6.72846 3.03018 7.61009 3.44952 8.27892L4.6564 10.1942L2.22219 12.1602C1.72102 12.5655 1.6392 13.3053 2.05854 13.8018C2.46765 14.2984 3.20405 14.3693 3.71544 13.964L5.92465 12.1804L6.46672 13.0317L7.25426 14.4909L6.54855 15.0584L5.06551 16.2542C4.51321 16.7001 4.18592 17.3689 4.18592 18.0783V19.9733L4.16547 23.8241C4.16547 24.4727 4.68709 24.9895 5.34166 24.9895C5.98602 24.9895 6.51786 24.4727 6.51786 23.8241L6.53832 18.0681L8.37932 16.5785L10.384 14.9672L11.6215 16.8825L12.6341 18.4431C12.9511 18.9295 13.4932 19.2234 14.0762 19.2335H15.5899L18.5355 19.2741C19.1901 19.2741 19.722 18.7572 19.722 18.1188C19.722 17.4804 19.2003 16.9534 18.556 16.9433L18.5355 16.9534Z"
          fill={bgColor}
        />
        <path
          d="M12.7477 13.2145L15.9797 16.0216C16.3786 16.3661 16.9718 16.3256 17.3195 15.9303L17.3707 15.8797L12.717 11.8262L12.6659 11.8768C12.3181 12.2721 12.359 12.8598 12.7579 13.2044L12.7477 13.2145Z"
          fill={bgColor}
        />
        <path d="M16.5933 7.44286L13.1797 11.2969L17.8382 15.3476L21.2518 11.4936L16.5933 7.44286Z" fill={bgColor} />
        <path
          d="M17.1034 6.86098L17.0625 6.90151L21.7161 10.955L21.7571 10.9145C22.1048 10.5193 22.0639 9.93151 21.665 9.58696L18.433 6.7799C18.0341 6.43536 17.4409 6.47589 17.0932 6.87111L17.1034 6.86098Z"
          fill={bgColor}
        />
        <path
          d="M16.2939 7.77331L15.8234 8.30027C15.3222 7.86451 14.504 7.99625 13.9824 8.58401C13.4608 9.17177 13.4403 10.0027 13.9415 10.4284L13.471 10.9553C12.7244 10.3068 12.7551 9.08057 13.5324 8.1888C14.3097 7.29702 15.537 7.11462 16.2836 7.76318L16.2939 7.77331Z"
          fill={bgColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_8051_225912">
          <rect width="22" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ClockIcon({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.63378 19.2906C14.9544 19.2906 19.2676 14.9722 19.2676 9.64528C19.2676 4.31834 14.9544 0 9.63378 0C4.31319 0 0 4.31834 0 9.64528C0 14.9722 4.31319 19.2906 9.63378 19.2906Z"
        fill="#7D86A9"
      />
      <path
        d="M11.5631 12.1966C11.3874 12.1966 11.2117 12.138 11.0653 11.9914L8.89844 9.93922V5.30714C8.89844 4.89671 9.22054 4.57422 9.63049 4.57422C10.0404 4.57422 10.3625 4.89671 10.3625 5.30714V9.32357L12.0609 10.936C12.3537 11.1998 12.383 11.6689 12.0902 11.9621C11.9438 12.1087 11.7388 12.1966 11.5631 12.1966Z"
        fill="white"
      />
    </svg>
  );
}

export function EyeIcon({ size, color }) {
  return (
    <svg
      t="1765360187106"
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="4672"
      width={size}
      height={size}
    >
      <path
        d="M512 768c-183.466667 0-328.533333-85.333333-426.666667-256 98.133333-170.666667 243.2-256 426.666667-256s328.533333 85.333333 426.666667 256c-98.133333 170.666667-243.2 256-426.666667 256z m8.533333-426.666667c-128 0-256 55.466667-328.533333 170.666667 72.533333 115.2 200.533333 170.666667 328.533333 170.666667s238.933333-55.466667 311.466667-170.666667c-72.533333-115.2-183.466667-170.666667-311.466667-170.666667z m-8.533333 298.666667c-72.533333 0-128-55.466667-128-128s55.466667-128 128-128 128 55.466667 128 128-55.466667 128-128 128z m0-85.333333c25.6 0 42.666667-17.066667 42.666667-42.666667s-17.066667-42.666667-42.666667-42.666667-42.666667 17.066667-42.666667 42.666667 17.066667 42.666667 42.666667 42.666667z"
        fill={color}
        p-id="4673"
      />
    </svg>
  );
}
